<template>
<div class="spring-travel-2023">
<SimpleHead />
    <div class="banner only-pc">
        <img src="https://media4.imgyb.xyz/media/v1/image/275b0484f51ae53785d2deca06c854b8.png" alt="">
    </div>
    <div class="banner only-mobile"><img src="https://media6.imgyb.xyz/media/v1/image/368d40f800eb871b509d28a57f911837.jpeg" alt=""></div>
    <div class="container">
        <TravelIntroduction />
        <div style="margin-top:20px"><a href="https://info.yorkbbs.ca/detail/kid1/130c7fb5-5c6c-4254-aa2c-024f66d3c328" target="_blank"><img src="https://media6.imgyb.xyz/media/v1/image/21f6c5cd7cbb9dab30aee54c476fb554.jpeg" alt=""> </a></div>
        <HotPlay />
        <div class="tab">
            <div class="item" :class="{active:type==0}" @click="typeChange(0)">精选推荐</div>
         
            <div class="item" :class="{active:type==2}" @click="typeChange(2)">最新发布 </div>
        </div>
        <div class="post-list" v-if="list.length>0" >
            <template v-for="(item,index) in list" >
                <div class="info-ad-content" v-if="item.app === 'crm_ad'" :key="index"><YorkbbsInfoflowItem  :data="item" ></YorkbbsInfoflowItem></div>
                
                <div class="post-item" v-else :key="item.id"><SubjectPostItem  :data="item" @attention="attention" /></div>
                
            </template>

            
        </div>
        <div class="loading-style" v-if="hasMore && listLoading " ><i class="el-icon-loading"></i> 加载中</div>
        <div class="loading-style" v-if="!hasMore" >没有更多了</div>
    </div>
    <div class="white-space"></div>
    <CssFooter></CssFooter> 
    <div class="join-play">
        <div class="box">
            <a @click="postLink($event)" :href="'/publish/parenting?subject=500419b6-536b-4341-a8bc-88d5913350aa'|hostBuild('forum')" target="_blank"><div><i class="el-icon-camera-solid"></i></div> 参与话题</a>
            <!-- <a @click="postLink($event)" href="javascript:void(0)"><div><i class="yk yk-cms_edit"></i></div> 参与话题</a> -->
        </div>

    </div>
</div>
</template>
<script>
import SimpleHead from '@/components/widgets/simple-head.vue'
import TravelIntroduction from './introduction.vue'
import { isScrollToPageBottom ,inflowAdvConvert} from '@/utils/utils';
import { throttle } from 'throttle-debounce';
import YorkbbsInfoflowItem from '@/components/item-infoflow.vue'


import SubjectPostItem from '@/components/subject-post-item.vue'
import CssFooter from '@/components/css-footer.vue'
import HotPlay from './hotPlay.vue'
export default {
    name:'ChildrenDay2023',
    components:{SimpleHead,TravelIntroduction,YorkbbsInfoflowItem,SubjectPostItem,CssFooter,HotPlay},
    data(){
        return {
            type:2,
            params:{
                subjectIds:['500419b6-536b-4341-a8bc-88d5913350aa'],
                dataOrigin:['bbs_post'],
                offset:1,
                size:10,
            },
           
            list:[],
            pageComplete:false,
            hasMore:true,
            listLoading:false,
        }
    },
    created(){
        this.getList();
    },
    mounted() {
        window.addEventListener('scroll', this.pageScroll);

        this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('scroll', this.pageScroll);
        });
    },
    methods:{
        typeChange(index){
            if( this.type == index) return false;
            delete this.params.options;
            if( index == 0 ){
                this.params.sort = ['property_top: DESC','property_commentedAt: DESC'];
                this.params['options'] = {"elite":[1]};
            }
            if( index ==1 ){
                this.params.sort = ['property_thumbUpTotal: DESC'];
            }
            if( index == 2 ){
                this.params.sort = ['property_commentedAt: DESC'];
            }
            this.type = index;
            this.params.offset = 1;
            this.hasMore = true;
            this.list = [];
            this.getList();
  
        },
        async getList(){
            this.listLoading = true;
            
            if( this.params.offset == 1 ){
                this.list = [];
            }
            if( this.type == 0 ){
                let result = await this.$axios.post('/subject/v1/post/list/recommended/for/special',this.params);
    
                let inflowAdv = inflowAdvConvert(result.data.items, 'subject', this.params.id);
                this.list = this.list.concat(inflowAdv);
                this.hasMore = this.list.length < result.data.itemTotal;
              
       
            }else{
                let result = await this.$axios.post('/subject/v1/post/list/latest/for/special',this.params);
                let inflowAdv = inflowAdvConvert(result.data.items, 'subject', this.params.id);
                this.list = this.list.concat(inflowAdv);
                this.hasMore = this.list.length < result.data.itemTotal;
             
            }
           

            this.pageComplete = true;
            this.listLoading = false;
        },
        pageScroll: throttle(300, function () {
            if( isScrollToPageBottom() && this.pageComplete && this.hasMore && !this.listLoading ){
                this.params.offset ++;
                this.getList();
            }
             
            /* let banner = this.$refs['banner'].scrollHeight;
            let top = document.documentElement.scrollTop || document.body.scrollTop;
            if( top>banner-100){
                this.showFunc = true;
            }else{
                this.showFunc = false;
            } */
 
            /* const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            const offsetTop = this.$refs.tab.offsetTop;
            this.tabFixed = scrollTop >= offsetTop; */
        }),
        postLink(event){
            console.log(event);
            try{
                
                flutterForumPost.postMessage(JSON.stringify({
                    topicId:'756f632a-c0d0-42fb-8daa-90683c34d55a',
                    subject:'500419b6-536b-4341-a8bc-88d5913350aa',
                    name:'育婴'
                }))
                event.preventDefault()
                return false;
            }catch(err){
                return true;
            }
            
        },
        attention(obj){
            
            for(var i=0; i<this.list.length;i++){
                if(this.list[i].app != 'bbs_post') continue;
                if( this.list[i].user.id == obj.id){
                    this.list[i].user.focusedByMe = obj.val;
                }
            }
        }
    }
}
</script>
<style lang="less" scoped>
.spring-travel-2023{
    background: #FFF9DF;
    .banner{background: url(https://media6.imgyb.xyz/media/v1/image/556d8e748d175cd84fc460956c793f40.png) no-repeat center top;
        img{display: block; margin:0 auto}
    }
    .container{
        width: 800px; margin: 0 auto; box-sizing: border-box;
    }
    .tab{
        display: flex; justify-content: center; margin: 35px 0 20px;
        .item{
            font-size: 20px; line-height: 36px; margin: 0 20px; user-select: none; cursor: pointer;
            &.active{
                color: #4D5F10; font-size: 26px; font-weight: bold;
                background:linear-gradient(rgba(255,255,255,0) 0%,rgba(255,255,255,1) 75%,rgba(255,255,255,1) 100% )
            }
        }
    }
    .post-list{
        .post-item{
            padding: 20px 30px; background:#fff; border-radius: 8px; margin-bottom: 20px;
        }
    }
    .loading-style{display: flex; padding-bottom: 20px; color: #999; justify-content: center ; align-items: center; font-size: 12px;
        i{margin-right: 5px;}
    }
    .white-space{height: 50px;}
}

@media screen and (max-width:768px){
    .spring-travel-2023{
        .container{
            width: 100%; padding: 0 10px; 
        }
        .join-play{
            position: fixed; z-index: 10; bottom: 150px;  right: 10px;
            .box{
                display: flex; flex-direction: column; align-items: center; justify-content: center; color: #fff; font-size: 20px; 
                  background: rgba(255, 139, 0, 1);

                width:76px; height: 76px; user-select: none; cursor: pointer;
                font-size: 12px; color: #fff; text-align: center;
                border-radius: 50%;
                i{font-size: 24px; margin-bottom: 3px;}
                &:hover{
                     background: rgba(255,139,0,.8); color: #fff;
                }
            }
        }
        .white-space{
            height: 20px;
        }
        .post-list{
            .post-item{padding: 15px;}
        }
    }
}
@media screen and (min-width:768px){
    .join-play{
            position: fixed; z-index: 10; bottom: 80px; left: 50%; right: 0; width: 800px; margin-left: -400px;
            .box{
                display: flex;  align-items: center; justify-content: center; color: #fff; font-size: 20px; 
               background: rgba(255, 139, 0, 1);

                height: 40px; user-select: none; cursor: pointer;
                font-size: 20px;  text-align: center;
                border-radius: 25px;
                i{font-size: 24px; margin-right: 5px;} 
                a{display: flex; align-items: center;}
                &:hover{
                    background: rgba(255,139,0,.8); color: #fff;
                }
            }
        }
}
.info-ad-content{
    padding: 0 25px; background: #fff; border-radius: 8px; margin-bottom: 20px;
}
@media screen and (max-width:768px){
    padding: 0 15px;
}
</style>